const getColumnsWidth = (columns: any[]) => {
  return columns.reduce((acc, val) => acc + val.width, 0);
};

export default getColumnsWidth;
